const MINUTES_PER_DAY = 24 * 60;

const asRecord = (value: unknown): Record<string, unknown> => {
  if (!value || typeof value !== "object") return {};
  return value as Record<string, unknown>;
};

const parseTimeToMinutes = (value: unknown): number | null => {
  if (typeof value !== "string") return null;
  const trimmed = value.trim();
  if (!trimmed) return null;

  const match = trimmed.match(/^([01]?\d|2[0-3]):([0-5]\d)(?::[0-5]\d)?$/);
  if (!match) return null;

  const hours = Number(match[1]);
  const minutes = Number(match[2]);
  return hours * 60 + minutes;
};

const parseDurationHours = (value: unknown): number | null => {
  if (typeof value === "number" && Number.isFinite(value) && value >= 0) {
    return value;
  }
  if (typeof value !== "string") return null;
  const trimmed = value.trim();
  if (!trimmed) return null;
  const parsed = Number(trimmed);
  if (!Number.isFinite(parsed) || parsed < 0) return null;
  return parsed;
};

export const getTourScheduledDurationHours = (timeFrom: unknown, timeTo: unknown): number | null => {
  const fromMinutes = parseTimeToMinutes(timeFrom);
  const toMinutes = parseTimeToMinutes(timeTo);
  if (fromMinutes === null || toMinutes === null) return null;

  if (fromMinutes === toMinutes) return 0;
  // If end is before start, treat it as crossing midnight.
  const diffMinutes = toMinutes > fromMinutes ? toMinutes - fromMinutes : toMinutes + MINUTES_PER_DAY - fromMinutes;
  return diffMinutes / 60;
};

export const shouldUseTourPriceOverride = (tour: unknown): boolean => {
  const tourRecord = asRecord(tour);
  const snapshotRecord = asRecord(tourRecord.tours);

  const scheduledHours = getTourScheduledDurationHours(tourRecord.time_from, tourRecord.time_to);
  const registeredHours = parseDurationHours(snapshotRecord.duration_hours);

  if (scheduledHours === null || registeredHours === null) return false;
  return scheduledHours > registeredHours;
};

export const getTourPriceOverride = (tour: unknown): number | null => {
  if (!shouldUseTourPriceOverride(tour)) return null;

  const tourRecord = asRecord(tour);
  const raw = tourRecord.price_override;
  if (raw === null || raw === undefined || raw === "") return null;

  const parsed = Number(raw);
  if (!Number.isFinite(parsed) || parsed < 0) return null;
  return parsed;
};
